import { render, staticRenderFns } from "./related-posts.vue?vue&type=template&id=8fc51f84&scoped=true"
import script from "./related-posts.vue?vue&type=script&lang=js"
export * from "./related-posts.vue?vue&type=script&lang=js"
import style0 from "./related-posts.vue?vue&type=style&index=0&id=8fc51f84&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc51f84",
  null
  
)

export default component.exports